import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import flowRight from 'lodash.flowright';
import { withStyles } from '@material-ui/styles';
import { Dialog, DialogContent, TextField } from '@material-ui/core';
import { Formik, Form } from 'formik';

import styles from './styles';
import { actions as reduxActions } from './reducers';
import { loginUser } from '../../pages/auth/actions/login';
import messageColors from '../../consts/messageColors';
import PrimaryButton from '../../partials/customButtons/PrimaryButton';
import SecondaryButton from '../../partials/customButtons/SecondaryButton';
import CustomDialogTitle from '../../partials/customDialogTitle/CustomDialogTitle';
import DraggableDialog from '../../partials/DraggableDialog';
import { translate } from '../../i18n/I18nProvider';
import DataInputBox from '../../partials/dataBox/DataInputBox';

const OtpCode = ({
  closeDialog,
  classes,
  open,
  login,
  password,
  error,
  loginUser,
  setError
}) => {
  const onSubmit = useCallback(
    values => {
      setError(null);
      loginUser({ login, password, code: values.code });
    },
    [login, password, loginUser]
  );

  return (
    <Dialog
      maxWidth="lg"
      classes={{
        paper: classes.root
      }}
      PaperComponent={DraggableDialog}
      open={open}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          closeDialog();
        }
      }}
    >
      <CustomDialogTitle onCloseClick={closeDialog}>
        {translate('OTP_CODE.TITLE')}
      </CustomDialogTitle>
      <DialogContent className={classes.dialogContent}>
        <div className={classes.infoText}>{translate('OTP_CODE.TEXT')}</div>

        <Formik initialValues={{ code: '' }} onSubmit={onSubmit}>
          {({ handleSubmit, values, handleChange, handleBlur, errors }) => {
            const fieldProps = { errors, values, handleBlur, handleChange };
            return (
              <Form className={classes.content} onSubmit={handleSubmit}>
                <DataInputBox
                  label={translate('OTP_CODE.LABEL')}
                  name="code"
                  width={280}
                  multiline={false}
                  {...fieldProps}
                />
                <div
                  className={classes.messageContainer}
                  style={{
                    color: messageColors.error,
                    visibility: error ? 'visible' : 'hidden'
                  }}
                >
                  {error}
                </div>
                <footer className={classes.footer}>
                  <SecondaryButton onClick={closeDialog}>
                    {translate('BUTTON.CLOSE')}
                  </SecondaryButton>
                  <PrimaryButton
                    onClick={handleSubmit}
                    disabled={values.code.length === 0}
                  >
                    {translate('BUTTON.SUBMIT')}
                  </PrimaryButton>
                </footer>
              </Form>
            );
          }}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

const mapStatesToProps = ({ otpCode }) => {
  return {
    ...otpCode
  };
};

const mapDispatchToProps = {
  closeDialog: reduxActions.closeDialog,
  setError: reduxActions.setError,
  loginUser
};

export default flowRight(
  withStyles(styles),
  connect(mapStatesToProps, mapDispatchToProps)
)(OtpCode);
